<script lang="ts" setup>
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import TableCell from '../TableCell.vue';
import { TrashBinTableContentViewModel } from './trashBinTableContentViewModel';
import { i18n } from '@/i18n';
import { TableContentProperty, TrashBinHeaderKey } from '../../interface/tableContentHeaders';
import { TableContentItem } from '../../interface/tableContentItems';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    trashBinHeaderKey: TrashBinHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isAllSelected: boolean;
    stableColumnCount: number;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {}
);

const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
  (e: 'onCheckboxSelected', displayId: string): void;
}>();

const TrashBinTableContentVM = new TrashBinTableContentViewModel();
const t = i18n.t;

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});
</script>
<template>
  <TableCell
    :class="[TrashBinTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: TrashBinTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="TrashBinTableContentVM.displayTrashBinItem(trashBinHeaderKey, item)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <template v-if="trashBinHeaderKey === 'TrashBinChoice'">
      <RowCheckBox
        v-if="!item.isVirtualChild"
        :is-checked="isChecked"
        class="md-primary all-check-button"
        @change-status="$emit('onCheckboxSelected', item.displayId)"
      />
    </template>
    <template v-else-if="trashBinHeaderKey === 'TrashBinDaysRemainUntilDeletion'">
      <span
        :class="Number(TrashBinTableContentVM.displayTrashBinItem(trashBinHeaderKey, item)) < 8 ? 'remainSevenDays' : ''"
        :style="'font-weight: initial;color: $semanticError;'"
        @click="emits('onClickNarrow')"
      >
        {{ TrashBinTableContentVM.displayTrashBinItem(trashBinHeaderKey, item) + t('日') }}
      </span>
    </template>
    <template v-else>
      <span class="table-cell-content" @click="emits('onClickNarrow')">
        {{ TrashBinTableContentVM.displayTrashBinItem(trashBinHeaderKey, item) }}
      </span>
    </template>
  </TableCell>
</template>

<style lang="scss" scoped>
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &--bold {
    font-weight: bold;
  }
}

.remainSevenDays {
  color: $semanticError;
}
</style>
